import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { BuyLedgerTable } from '@/components/Pages/Ledgers/BuyLedgerTable';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/ledgers/buys/')({
  component: BuyLedgersPage,
  head: () => pageTitle('Pagos'),
});

function BuyLedgersPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('BUY_READ');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      <BuyLedgerTable
        emptyMessage='No hay compras registradas'
        errorTitle='Error al cargar las compras'
      />
    </Box>
  );
}
